let token: string | undefined;

/** Sets the current Cognito ID token (kept in sync by AuthGate; undefined when signed out). */
export const setAuthToken = (next: string | undefined): void => {
  token = next;
};

/** The current Cognito ID token, attached as the bearer token by RTK Query and axios. */
export const getAuthToken = (): string | undefined => {
  return token;
};
